import './Popup.css';
import React, { useState, useRef, useEffect, createContext } from 'react';
import { Button, CloseIcon } from './Buttons.js';
import { PageLine } from './pageline.js';


export function Popup({ title, size = 'medium', onClose, content, style, className = '', Background }) {
    const [open, setOpen] = useState('')

    const transition = 0.3

    const popupMenuRef = useRef(null);
    useEffect(() => {
        setOpen('open')
    }, [])

    const popupStyle = {
        transition: 'transform ' + transition + 's ease-in-out',
        ...style
    }
    return (
        <div className={"popup-container " + open} ref={popupMenuRef} style={{ transition: 'background-color ' + transition + 's' }}>

            <div className={"popup " + size + ' ' + className} style={popupStyle}>
                <div className="popup-bar" >
                    <CloseIcon click={() => { setOpen(''); setTimeout(() => { if (onClose) { onClose() } }, transition * 1000) }} />
                </div>
                <PageLine />
                <div className="popup-content">
                    <div className="popup-title title">
                        {title}
                    </div>
                    {content}
                </div>
                {Background && <Background />}
            </div>

        </div>

    );
};
